module.exports = __webpack_public_path__ + "static/10-2b851a14812b3e45f9445693a04e87c0.jpg";